export default "__VITE_ASSET__4366f23b__"